import { Component } from '@angular/core';

@Component({
	selector: 'app-confirmation-requests',
	templateUrl: './confirmation-requests.component.html',
	styleUrls: ['./confirmation-requests.component.css']
})
export class ConfirmationRequestsComponent {
	sendRequest() {
		window.location.href = 'https://www.confirmation.com/home.aspx';
	}
}
